var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.post)?_c('div',[_c('v-btn',{attrs:{"elevation":"0","small":"","text":""},on:{"click":function($event){return _vm.updateEmotions(_vm.reactions.oss)}}},[_c('IconOss',{staticClass:"hero-button",attrs:{"size":"25","color":_vm.reacted == _vm.reactions.oss ? _vm.themeColor('error') : _vm.themeColor('gray')}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }